<div class="one-column">
    <h1>Nutzerverwaltung</h1>
    <mat-tab-group>
        <mat-tab label="Bestätigte Nutzer">
            <mat-card>
                <app-search-bar (searchChange)="onSearchChange($event)"></app-search-bar>
                <div class="table">
                    <div class="row border">
                        <div><b>Nutzer</b></div>
                        <div><b>Rolle</b></div>
                        <div>
                            <b>Composer-Nutzungsrechte</b>
                        </div>
                        <div>
                            <b>Nutzer zur Organisation einladen</b>
                        </div>
                        <div><b>Nutzer löschen</b></div>
                    </div>
                    <div *ngFor="let user of userRoleGroups; let i = index" class="row">
                        <div>
                            <p>{{ user.userName }}</p>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-select [(value)]="user.userRole" (selectionChange)="
                                        changeUserRole($event, user.userId)
                                    ">
                                    <mat-option [value]="'USER'">USER</mat-option>
                                    <mat-option [value]="'PLATTFORMADMIN'">PLATTFORMADMIN</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="center-elements">
                            <mat-checkbox [(ngModel)]="user.hasComposerAccess" (ngModelChange)="
                                    changeComposerAccess($event, user.userId)
                                ">
                            </mat-checkbox>
                        </div>
                        <div class="center-elements">
                            <button matButton="elevated" color="primary" (click)="onAddOrganisationToggle(i)">
                                Nutzer zu Organisation hinzufügen
                            </button>
                        </div>
                        <div class="center-elements">
                            <button matButton="elevated" color="warn" (click)="deleteUser(user.userId)">
                                Nutzer löschen
                            </button>
                        </div>

                        <div *ngIf="dataSourceUserRoles.addOrganisationMode[i]">
                            <div class="columns-50-50">
                                <mat-form-field>
                                    <mat-label>Organisation</mat-label>
                                    <mat-select [(ngModel)]="
                                            addOrganisation.organisationName
                                        ">
                                        <mat-option *ngFor="
                                                let organisation of organisations
                                            " value="{{ organisation }}">{{ organisation }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Rolle</mat-label>
                                    <mat-select [(value)]="addOrganisation.role">
                                        <mat-option [value]="'ADMIN'">Administrator</mat-option>
                                        <mat-option [value]="'USER'">Benutzer</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="columns-50-50">
                                    <button matButton="elevated" class="green-confirm"
                                        (click)="addOrganisationMembership(i)">
                                        Ok
                                    </button>
                                    <button matButton="elevated" color="warn" (click)="onAddOrganisationToggle(i)">
                                        Abbrechen
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-paginator [length]="totalNumberOfElements" [pageIndex]="this.pageIndex"
                        [pageSize]="this.pageSize" (page)="onPageChange($event)"
                        [pageSizeOptions]="[5, 10]"></mat-paginator>
                </div>
            </mat-card>
        </mat-tab>
        <mat-tab label="Unbestätigte Nutzer">
            <app-unconfirmed-user-management></app-unconfirmed-user-management>
        </mat-tab>
    </mat-tab-group>
</div>